<div fxLayout="column">
    <div *ngFor="let bank of banks" fxLayout="column" class="bank">
        <span class="bold">Bank</span>
        <span class="name">{{bank}}</span>

        <div fxFlex="auto" fxLayout="row" fxLayoutAlign="space-between start" class="bold header">
            <div fxFlex="55" fxLayout="row" fxLayoutAlign="start start">
                <span fxFlex="33">Vendor Name</span>
                <span fxFlex="33">Payable Number</span>
                <span fxFlex="33">Description</span>
            </div>
            <div fxFlex="45" fxLayout="row" fxLayoutAlign="end start" class="bold numeric">
                <span fxFlex="25">Invoice Date</span>
                <span fxFlex="25">Payable Due Date</span>
                <span fxFlex="25">Discount Amount</span>
                <span fxFlex="25">Payable Amount</span>
            </div>
        </div>

        <div *ngFor="let vendor of getVendors(bank)" fxLayout="column" class="vendor">

            <div *ngFor="let payment of getPayments(vendor); first as isFirstPayment" fxLayout="column">

                <div *ngFor="let invoice of payment.Payables; first as isFirstInvoice" fxFlex="auto" fxLayout="column" class="mt10">

                    <div fxFlex="auto" fxLayout="row" fxLayoutAlign="space-between start">

                        <div fxFlex="55" fxLayout="row" fxLayoutAlign="start start">
                            <span *ngIf="isFirstPayment && isFirstInvoice" fxFlex="33">{{payment.Vendor}}</span>
                            <span *ngIf="!(isFirstPayment && isFirstInvoice)" fxFlex="33"></span>
                            <span fxFlex="33">{{invoice.Number}}</span>
                            <span fxFlex="33">{{invoice.Description}}</span>
                        </div>

                        <div fxFlex="45" fxLayout="row" fxLayoutAlign="end start" class="numeric">
                            <span fxFlex="25">{{invoice.PayableDate | date:'M/d/yyyy'}}</span>
                            <span fxFlex="25">{{invoice.DueDate | date:'M/d/yyyy'}}</span>
                            <span fxFlex="25">{{invoice.DiscountAmount | currency}}</span>
                            <span fxFlex="25">{{invoice.TotalAmount | currency}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div fxFlex="auto" fxLayout="row" fxLayoutAlign="space-between start">
                <div fxFlex="55"></div>
                <div fxFlex="45" fxLayout="column">
                    <div fxLayout="row" fxLayoutAlign="end start" class="numeric bold header">
                        <span fxFlex="25">Payment Type</span>
                        <span fxFlex="25">Payment Number</span>
                        <span fxFlex="25">Date</span>
                        <span fxFlex="25">Amount</span>
                    </div>

                    <div *ngIf="!hasPayments(getPayments(vendor))" class="numeric row">
                        No Payments
                    </div>

                    <ng-container *ngFor="let payment of getPayments(vendor)">
                        <div *ngIf="hasPayments(getPayments(vendor))" fxLayout="row" fxLayoutAlign="end start" class="numeric row">
                            <span fxFlex="25">{{payment.PaymentType}}</span>
                            <span fxFlex="25">{{payment.PaymentNumber}}</span>
                            <span fxFlex="25">{{payment.PaymentDate | date:'M/d/yyyy'}}</span>
                            <span fxFlex="25">{{payment.TotalPayment | currency}}</span>
                        </div>
                    </ng-container>

                    <mat-divider></mat-divider>
                </div>
            </div>
        </div>

        <mat-divider></mat-divider>
    </div>

    <div fxFlex="auto" fxLayout="column" class="summary">

        <h3>Payment Summary</h3>

        <div fxLayout="column" class="center">
            <div fxFlex="50" fxLayout="row">
                <span fxFlex="30" class="bold">Type</span>
                <span fxFlex="20" class="bold numeric">Count</span>
                <span fxFlex="50" class="bold numeric">Total Amount</span>
            </div>

            <div *ngIf="!hasTotalPayments" fxFlex="auto" class="numeric row">
                No Payments
            </div>

            <ng-container *ngIf="hasTotalPayments">
                <div *ngFor="let total of totals" fxLayout="row" fxLayoutAlign="space-between start" class="row">
                    <span fxFlex="30">{{total.key}}</span>
                    <span fxFlex="20" class="numeric">{{total.value.count}}</span>
                    <span fxFlex="50" class="numeric">{{total.value.amount | currency}}</span>
                </div>
            </ng-container>

            <mat-divider></mat-divider>
        </div>

        <div *ngIf="grandTotal > 0" class="grandTotal">
            <div fxLayout="row" fxLayoutAlign="space-between start">
                <span fxFlex="30" class="bold">Totals:</span>
                <span fxFlex="20" class="numeric">{{count}}</span>
                <span fxFlex="50" class="numeric">{{grandTotal | currency}}</span>
            </div>
        </div>
    </div>
</div>
